import { useKeycloak } from '@react-keycloak/web';
import React, { useState } from 'react';
import Layout from './components/Layout/Layout';
import ErrorModal from './components/Modals/ErrorModal';
import { axiosDefaults } from './config/axiosDefaults';
import ScrollTop from './router/ScrollTop';

const AppWrapper = (): JSX.Element => {
  const { keycloak } = useKeycloak();
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  axiosDefaults(keycloak, setLoading, setErrorMessage);

  return (
    <>
      <ScrollTop />
      <Layout loading={loading} />
      <ErrorModal
        open={!!errorMessage}
        handleClose={() => setErrorMessage('')}
        message={errorMessage}
      />
    </>
  );
};

export default AppWrapper;
